import { InputAdornment } from '@mui/material'
import debounce from 'lodash/debounce'
import { forwardRef, useRef } from 'react'
import { Icons, SearchInputField, SearchInputFieldProps } from 'utoniq-ui'

import { useForm, UseFormProps, useTranslation } from '@/core'
import { CellFrame, Organism, OrganismFrame } from '@/core/architecture'

export type AutocompleteFormProps = {
  onSubmit: (values: SearchFormValues) => Promise<void>
  onGoBack: () => void
}

type SearchFormValues = {
  keyword: string
}

const schema: UseFormProps['schema'] = o => ({
  keyword: o.string(),
})

export const AutocompleteForm: Organism<AutocompleteFormProps> = ({
  onSubmit,
  onGoBack,
}) => {
  const { handleSubmit, register, setValue } = useForm<SearchFormValues>({
    schema,
    defaultValues,
  })
  const handleChangeKeywordDebounce = useRef(
    debounce(handleSubmit(onSubmit), 500)
  )

  return (
    <OrganismFrame sx={{ px: 5 }}>
      <SearchInputCell
        {...register('keyword')}
        onChange={async event => {
          setValue('keyword', event.target.value)
          await handleChangeKeywordDebounce.current()
        }}
        textFieldProps={{
          InputProps: {
            startAdornment: (
              <InputAdornment
                position="start"
                onClick={onGoBack}
                sx={{ cursor: 'pointer' }}
              >
                <Icons.Back fontSize="small" sx={{ color: 'grey.700' }} />
              </InputAdornment>
            ),
          },
        }}
      />
    </OrganismFrame>
  )
}

const SearchInputCell = forwardRef(
  (props: Omit<SearchInputFieldProps, 't'>, ref) => {
    const { t } = useTranslation('consoleMissions')
    return (
      <CellFrame sx={{ width: '100%' }}>
        <SearchInputField {...props} ref={ref} t={t} />
      </CellFrame>
    )
  }
)

const defaultValues: SearchFormValues = {
  keyword: '',
}
